import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        minWidth: '32rem',
    },
    // Dos columnas para los pares de porcentajes, que solo se entienden juntos.
    fieldPair: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: tokens.spacingHorizontalM,
    },
    switchRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
    },
    // La vista previa es lo que evita que el usuario tenga que confiar en que
    // los porcentajes hicieron lo que esperaba: muestra el reparto ya resuelto.
    preview: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        padding: tokens.spacingVerticalM,
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorNeutralBackground2,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
    },
    previewRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
    },
    previewLabel: {
        color: tokens.colorNeutralForeground2,
    },
    previewValue: {
        fontVariantNumeric: 'tabular-nums',
        color: tokens.colorNeutralForeground1,
    },
    previewValueNegative: {
        fontVariantNumeric: 'tabular-nums',
        color: tokens.colorPaletteRedForeground1,
    },
    previewTotalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: tokens.spacingHorizontalM,
        paddingTop: tokens.spacingVerticalXS,
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        fontWeight: tokens.fontWeightSemibold,
    },
    // Acciones por fila dentro de la grilla de valores.
    rowActions: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalXXS,
    },
    deleteSummary: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        padding: tokens.spacingVerticalM,
        borderRadius: tokens.borderRadiusMedium,
        backgroundColor: tokens.colorNeutralBackground2,
    },
});
